var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-container",class:{
    selectable: !_vm.selected,
    'left-tab': _vm.left,
    'right-tab': _vm.right,
  }},[_c('div',{staticClass:"tab-title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }